export const anyObject: any = {};
